// eslint-disable-next-line import/prefer-default-export
export const avatarPlaceholder =
  // eslint-disable-next-line max-len
  'https://storage.gra.cloud.ovh.net/v1/AUTH_1aa44ccb48c74c7f956a0ce09a3527ea/static001/events/GC702HNzdUXWPD/files/lC1aBf29usn7GU.png';
